function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ModtoolsAppPermissionsTemplate = require('./modtools-app-permissions.template');
var ModtoolsAdPermissionTemplate = require('./modtools-add-permission.template');
var SaitoOverlay = require('../../../lib/saito/ui/saito-overlay/saito-overlay');
var ModtoolsAppPermissions = /*#__PURE__*/function () {
  function ModtoolsAppPermissions(app, mod, container) {
    _classCallCheck(this, ModtoolsAppPermissions);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(this.app, this.mod);
  }
  return _createClass(ModtoolsAppPermissions, [{
    key: "render",
    value: function render() {
      this.displayAppPermissions();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var this_self = this;

      // add new app permission
      if (document.querySelector('#modtools-apps-add-new')) {
        document.querySelector('#modtools-apps-add-new').onclick = function (e) {
          // show add new permission UI
          document.querySelector('#add-new-permission-box').style.display = 'block';
          document.querySelector('#modtools-apps-add-new').style.display = 'none';
          document.querySelector('#add-new-permission-box').innerHTML = ModtoolsAdPermissionTemplate(this_self.app, this_self.mod);

          //clicked on cancel
          document.querySelector('#modtools-cancel-permission-btn').onclick = function (e) {
            document.querySelector('#add-new-permission-box').innerHTML = "";
            document.querySelector('#modtools-apps-add-new').style.display = 'block';
            document.querySelector('#add-new-permission-box').style.display = 'none';
          };

          //clicked on add
          document.querySelector('#modtools-add-permission-btn').onclick = function (e) {
            var app_selected = document.querySelector('#modtools-add-permission-app').value;
            app_selected = app_selected.toLowerCase();
            var value_selected = document.querySelector('#modtools-add-permission-option').value;
            console.log('app_selected - value_selected', app_selected, value_selected);
            this_self.mod.apps[app_selected] = value_selected;
            this_self.mod.save();
            this_self.displayAppPermissions();
            this_self.attachEvents();
            document.querySelector('#add-new-permission-box').innerHTML = "";
            document.querySelector('#modtools-apps-add-new').style.display = 'block';
            document.querySelector('#add-new-permission-box').style.display = 'none';
          };
        };
      }
      if (document.querySelector('.app-permission-option')) {
        document.querySelectorAll('.app-permission-option').forEach(function (elem) {
          elem.onchange = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
              var value, app_name, confirm;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    value = e.target.value;
                    app_name = e.target.getAttribute('data-app-name'); // confirm for delete
                    if (!(value == '-')) {
                      _context.n = 2;
                      break;
                    }
                    _context.n = 1;
                    return sconfirm("Are you sure you want to delete permission for '".concat(app_name, "'?"));
                  case 1:
                    confirm = _context.v;
                    console.log('confirm answer:', confirm);
                    if (confirm) {
                      console.log('deleting option');
                      delete this_self.mod.apps[app_name];
                    }
                    _context.n = 3;
                    break;
                  case 2:
                    this_self.mod.apps[app_name] = value;
                  case 3:
                    console.log('value:', value);
                    console.log('e:', app_name);
                    this_self.mod.save();
                    this_self.displayAppPermissions();
                    this_self.attachEvents();
                  case 4:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
        });
      }
    }
  }, {
    key: "displayAppPermissions",
    value: function displayAppPermissions() {
      document.querySelector('#modtools-app-permissions').innerHTML = "";
      var html = "";
      this.mod.load();
      var apps = this.mod.apps;
      if (Object.keys(apps).length == 0) {
        html = "No app permissions to show";
      } else {
        for (var key in apps) {
          html += "\n              <div class=\"app-permission-option\">\n                  <div class=\"app-name\">".concat(key.toUpperCase(), "</div>\n                  <div class=\"overlay-input\">\n                  <select data-app-name=\"").concat(key.toLowerCase(), "\" class=\"saito-form-select app-options-select\" >\n                      <option value=\"*\" ").concat(apps[key] == '*' ? "selected" : "", ">Allow all</option>\n                      <option value=\"!\" ").concat(apps[key] == '!' ? "selected" : "", ">None</option>\n                      <option value=\"$\" ").concat(apps[key] == '$' ? "selected" : "", ">Fee-bearing</option>\n                      <option value=\"-\">Remove</option>\n                  </select>\n                  </div>\n              </div>\n              ");
        }
      }
      document.querySelector('#modtools-app-permissions').innerHTML = html;
    }
  }]);
}();
module.exports = ModtoolsAppPermissions;